var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.745728L6.25 9.49573M6.25 2.49573H2.75C2.28587 2.49573 1.84075 2.6801 1.51256 3.00829C1.18437 3.33648 1 3.7816 1 4.24573V12.9957C1 13.4599 1.18437 13.905 1.51256 14.2332C1.84075 14.5614 2.28587 14.7457 2.75 14.7457H11.5C11.9641 14.7457 12.4092 14.5614 12.7374 14.2332C13.0656 13.905 13.25 13.4599 13.25 12.9957V9.49573L6.25 2.49573ZM9.75 0.745728H15H9.75ZM15 0.745728V5.99573V0.745728Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.423dbc25d813a556cc65f521b15169c3.svg";
export { ForwardRef as ReactComponent };